module.exports = __webpack_public_path__ + "assets/img_beer_and_wine.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_beer_and_wine.png
 ** module id = 117
 ** module chunks = 1
 **/